/* eslint-disable */

var icon = require('vue-svgicon')
icon.register({
  'ellipse': {
    width: 123,
    height: 122,
    viewBox: '0 0 123 122',
    data: `<desc>Created using Figma</desc><use xlink:href="#svgicon-ellipse-a" transform="rotate(68 43.247 65.052)" fill="#FFF" fill-opacity=".3"/><defs><path pid="0" id="svgicon-ellipse-a" d="M92.975 92.475C41.903 92.475.5 51.073.5 0h-1c0 51.625 41.85 93.475 93.475 93.475v-1z"/></defs>`
  }
})
